import { useAuth } from './context/auth';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
    const auth = useAuth();
    return auth.user ? children : <Navigate to="/" />
};

